import api from '@/api';

const resource = 'merenda/usuario-deposito';

export default {
  criarUsuarioDeposito( data ) {
    return api.post( `${resource}`, data );
  },

  editarUsuarioDeposito( data ) {
    return api.put( `${resource}/${data.identificadorusuariodepositomerenda}`, data);
  },

  deletarUsuarioDeposito( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarUsuarioDeposito(data) {
    return api.get( `${resource}`, {
      params: data
    } );
  },
  getPerfisModuloMerenda(identificadorperfil) {
    return api.get( `${resource}/perfis-modulo-merenda`, {
      params: {
        identificadorperfil,
      }
    } );
  },
  obterIdentificadorEscola(cdtipesc, cdescola)
  {
    return api.get( `${resource}/escola/${cdtipesc}/${cdescola}`)
  }
};
